module.exports = __webpack_public_path__ + "static/media/hero-snap-two.9d8fe932.jpg";